

import React from "react";

const ChangePasswordIcon = () => {
  return (
<svg width="16" height="16" viewBox="0 0 15 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.836139 8V7.27778H14.1639V8H0.836139ZM1.21142 3.6862L0.676908 3.36698L1.35382 2.14426H0V1.50582H1.35382L0.676908 0.319942L1.21142 0L1.88833 1.1866L2.56594 0L3.09975 0.319942L2.42284 1.50582H3.77666V2.14426H2.42284L3.09975 3.36698L2.56524 3.6862L1.88833 2.46421L1.21142 3.6862ZM6.82309 3.6862L6.28858 3.36698L6.96619 2.14426H5.61167V1.50582H6.96549L6.28858 0.319942L6.82309 0L7.5 1.1866L8.17761 0L8.71142 0.319942L8.03451 1.50582H9.38833V2.14426H8.03451L8.71142 3.36698L8.17691 3.6862L7.5 2.46421L6.82309 3.6862ZM12.4348 3.6862L11.9003 3.36698L12.5779 2.14426H11.2233V1.50582H12.5772L11.9003 0.319942L12.4348 0L13.1117 1.1866L13.7893 0L14.3231 0.319942L13.6462 1.50582H15V2.14426H13.6462L14.3231 3.36698L13.7886 3.6862L13.1117 2.46421L12.4348 3.6862Z" fill="white"/>
</svg>

  );
};

export default ChangePasswordIcon;